import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { storage, authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import moment from 'moment';
import {
    SCHEDULE_MTO_EVENT_LIST,
    SCHEDULE_MTO_DETAIL_EVENT_LIST,
    SCHEDULE_MTO_REMINDER
} from '../../actions';
import {
    ScheduleMtoEventListSuccess,
    ScheduleMtoEventListError,
    ScheduleMtoDetailEventListSuccess,
    ScheduleMtoDetailEventListError,
    ScheduleMtoReminderSuccess,
    ScheduleMtoReminderError
} from '../../actions';

export function* watchScheduleMtoEventList() {
    yield takeEvery(SCHEDULE_MTO_EVENT_LIST, onScheduleMtoEventList);
}

export function* watchScheduleMtoDetailEventList() {
    yield takeEvery(SCHEDULE_MTO_DETAIL_EVENT_LIST, onScheduleMtoDetailEventList);
}

export function* watchScheduleMtoReminder() {
    yield takeEvery(SCHEDULE_MTO_REMINDER, onScheduleMtoReminder);
}

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onScheduleMtoEventListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'scheduleMto/eventlist', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onScheduleMtoDetailEventListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'scheduleMto/detaileventlist', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onScheduleMtoReminderAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'scheduleMto/reminder', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

function* onScheduleMtoEventList(data) {
    try {
        const response = yield call(onScheduleMtoEventListAsync, data.payload);
        yield put(ScheduleMtoEventListSuccess(response.data));
    } catch (error) {
        yield put(ScheduleMtoEventListError(error));
    }
}

function* onScheduleMtoDetailEventList(data) {
    try {
        const response = yield call(onScheduleMtoDetailEventListAsync, data.payload);
        yield put(ScheduleMtoDetailEventListSuccess(response.data));
    } catch (error) {
        yield put(ScheduleMtoDetailEventListError(error));
    }
}

function* onScheduleMtoReminder(data) {
    try {
        const response = yield call(onScheduleMtoReminderAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(ScheduleMtoReminderSuccess(response.data));
    } catch (error) {
        yield put(ScheduleMtoReminderError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchScheduleMtoEventList),
        fork(watchScheduleMtoDetailEventList),
        fork(watchScheduleMtoReminder)
    ]);
}